import HttpClient from "./api";

class SimpleHttpApi extends HttpClient {
    public constructor() {
        super();
    }
}

export const httpApi = new SimpleHttpApi();